export default "__VITE_ASSET__884c52b8__"